import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShippingExpressIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 35 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2 7.89453H8.73709M4.52641 12.1052H7.89496'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.1603 18.8427H19.7988C20.6276 18.8427 21.3332 18.2398 21.4625 17.4211L23.59 3.94696C23.7514 2.92467 22.9613 2 21.9263 2H11.1533C10.3245 2 9.61887 2.60294 9.48961 3.42159L7.3621 16.8958C7.20069 17.9181 7.99081 18.8427 9.02577 18.8427H10.4232'
          stroke='currentColor'
          strokeWidth='2'
        />
        <path
          d='M23.8927 5.37109H27.9688C31.113 5.37109 33.4937 8.21193 32.9438 11.3076L31.8517 17.4556C31.7089 18.2596 31.01 18.8453 30.1934 18.8453H28.9455M18.8398 18.8453H22.2084'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
        />
        <circle cx='13.7904' cy='18.8451' r='3.36855' stroke='currentColor' strokeWidth='2' />
        <circle cx='25.5795' cy='18.8451' r='3.36855' stroke='currentColor' strokeWidth='2' />
      </svg>
    </SvgIcon>
  );
};
